import React, { useEffect, useState } from "react";
import Pump from "../components/UI/pump/Pump";
import PumpGroup from "../components/UI/pump_group/PumpGroup";
import PumpStation from "../components/UI/pump_station/PumpStation";
import ValueText from "../components/UI/value_text/ValueText";
import "../styles/Schema.css";
import FitRow from "../components/UI/fitrow/FitRow";

const Schema = () => {
  console.log("schema loaded");
  useEffect(() => {
    console.log("Schema - create");
  }, []);

  return (
    <div className="App ">
      <div className="back"></div>
      <div className="schema">
        {/* <div className="back"> </div> */}

        <PumpStation
          name="Приемная камера"
          varName="n1.w1"
          maxLevel={4}
          left={60}
          top={60}>
          <ValueText props={{ varName: "n1.w1", digits:"2", meas: "м" }} />
          <PumpGroup>
            <Pump st="n1.1s" fq="n1.1f" />
            <Pump st="n1.2s" fq="n1.2f" />
            <Pump st="n1.3s" fq="n1.3f" />
            <Pump st="n1.4s" fq="n1.4f" />
          </PumpGroup>
        </PumpStation>
        <PumpStation name="Усреднитель" varName="n2.w2" left={500} top={60}>
          <ValueText props={{ varName: "n2.w2", digits:"2", meas: "м" }} />
          <PumpGroup>
            <Pump st="n2.1s" fq="n2.1f" />
            <Pump st="n2.2s" fq="n2.2f" />
            <Pump st="n2.3s" fq="n2.3f" />
            <Pump st="n2.4s" fq="n2.4f" />
          </PumpGroup>
        </PumpStation>
        
        <FitRow>
          <ValueText props={{name:"т1: ",  varName: "fit1", meas: "м³/ч" }} />
          <ValueText props={{name:"т2: ",  varName: "fit2", meas: "м³/ч" }} />
          <ValueText props={{name:"т3: ",  varName: "fit3", meas: "м³/ч" }} />
          <ValueText props={{name:"т4: ",  varName: "fit4", meas: "м³/ч" }} />
          <ValueText props={{name:"КНС: ", varName: "fit5", meas: "м³/ч" }} />
        </FitRow>
        <PumpStation name="Илонакопитель" varName="n5.w5" maxLevel={6} left={500} top={460}>
          <ValueText props={{ varName: "n5.w5", digits:"2", meas: "м" }} />
          <PumpGroup>
            <Pump st="n5.1s" fq="n5.1f" />
            <Pump st="n5.2s" fq="n5.2f" />
            <Pump st="n5.3s" fq="n5.3f" />
          </PumpGroup>
        </PumpStation>
        
        <PumpStation name="РУЧВ" varName="n6.w6" maxLevel={6} left={500} top={460}>
          <ValueText props={{ varName: "n6.w6", digits:"2", meas: "м" }} />
          <PumpGroup>
            <Pump st="n6.1s" fq="n6.1f" />
            <Pump st="n6.2s" fq="n6.2f" />
            <Pump st="n6.3s" fq="n6.3f" />
            <Pump st="n6.4s" fq="n6.4f" />
          </PumpGroup>
        </PumpStation>
        <PumpStation name="РЧВ" varName="n7.w7" maxLevel={6} left={60} top={460}>
          <ValueText props={{ varName: "n7.w7", digits:"2", meas: "м" }} />
          <PumpGroup>
            <Pump st="n7.1s" fq="n7.1f" />
            <Pump st="n7.2s" fq="n7.2f" />
            <Pump st="n7.3s" fq="n7.3f" />
            <Pump st="n7.4s" fq="n7.4f" />
          </PumpGroup>
        </PumpStation>
        <FitRow>
          <ValueText props={{ varName: "fit6", meas: "м³/ч" }} />
          <ValueText props={{ varName: "fit7", meas: "м³/ч" }} />
        </FitRow>
      </div>
    </div>
  );
};

export default Schema;
